import * as Actions from '../../actions/inspection/type';

const initialState = {
  backendError: {},
  success: {},
  message: {},
  inspections: null,
};
export const AddInspectionCustomerAndVehicle = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case Actions.CLEAR_CUSTOMER_STATE:
      return { ...state, backendError: {}, success: {}, message: {} };
    case Actions.FETCH_INSPECTIONS_REQUEST:
      return { loading: true };
    case Actions.FETCH_INSPECTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        inspections: action.payload,
      };
    case Actions.FETCH_INSPECTIONS_FAIL:
      return {
        ...state,
        loading: false,
        backendError: { ...state.backendError, ...action.payload },
      };
    default:
      return state;
  }
};
